// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"1b268c77","76":"bc59a861","403":"4d142b26","420":"f73f85e9","444":"c871a87c","453":"5f3842d5","763":"99a66b2c","916":"0c1337af","931":"84151a5c"}[chunkId] + ".chunk.js";
};